import { Card, Button, Badge, Image } from "react-bootstrap";
import "./anniversary.css";

export const ProfileCard = ({
  name,
  role,
  image,
  action,
  employeeId,
  date,
}) => {
  return (
    <Card className="work-anniversary-card">
      <Card.Body className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <Image src={image} roundedCircle className="profile-image" />
          <div className="ms-3">
            <Card.Title className="mb-0 color-white profile-name">
              {name}
            </Card.Title>
            <Card.Text className="profile-role color-gray">{employeeId}</Card.Text>
            <Card.Text className="profile-role color-gray">{role}</Card.Text>
            <Card.Text className="profile-role color-gray">{date}</Card.Text>
          </div>
        </div>
        <Button className="wish-button" onClick={action}>
          Wish
        </Button>
      </Card.Body>
    </Card>
  );
};

export const CardContainer = ({ children, title, variant }) => {
  return (
    <div className="card_container">
      <div className={`work-anniversary-badge ${variant} `}>{title}</div>
      {children}
    </div>
  );
};
